export const colorBgBase = '#12141c';
export const colorBgContainer = '#1c1f2c';
export const colorBgElevated = '#232736';
export const colorSider = '#171a24';
export const colorBorder = 'rgba(255, 255, 255, 0.08)';

export const colorPrimary = '#e23d47';
export const colorAccent = '#ffd265';

export const colorText = '#e9ebf5';
export const colorTextMuted = '#9aa1b5';

// Standard gaming rarity colors — instantly familiar to players.
export const rarityColors: Record<string, string> = {
    common: '#8c8c8c',
    uncommon: '#52c41a',
    rare: '#1677ff',
    epic: '#9254de',
    legendary: '#faad14',
    unrevealed: '#13c2c2',
    'no rarity': '#595959',
};

export const rarityOrder = ['legendary', 'epic', 'rare', 'uncommon', 'common', 'unrevealed', 'no rarity'];
